// import

import type {SupportNode, SupportMainNode} from '@arc/hub-model';
import type {GetStaticProps} from 'next';

import * as R from 'ramda';

import {revalidate} from 'libs/constants';
import db from 'libs/db';
import {SupportMainPage} from 'modules/Support';

// types

type Props = {
  main: SupportMainNode;
  supports: Array<Pick<SupportNode, 'meta'>>;
};

// component

export default function SupportView(props: Props) {
  const {main, supports} = props;

  return (
    <SupportMainPage main={main} supports={supports} />
  );
}

// data

export const getStaticProps: GetStaticProps<Props> =
  async ({preview}) => {
    const [main, supports] = await Promise.all([
      db.readSupportMain({preview}),
      db.readSupports(undefined, {preview}),
    ]);

    if (!main) {
      return {notFound: true};
    }

    return {
      revalidate,
      props: {
        main,
        supports: supports.map(R.pick(['meta'])),
      },
    };
  };

